import { render, staticRenderFns } from "./BotView.html?vue&type=template&id=4872645e&scoped=true&external"
import script from "./BotView.js?vue&type=script&lang=js&external"
export * from "./BotView.js?vue&type=script&lang=js&external"
import style0 from "./BotView.scss?vue&type=style&index=0&id=4872645e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4872645e",
  null
  
)

export default component.exports